import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { admiDataCatalogService } from '../admi-data-catalog.service';
import { DataCatalogDto } from '../data-catalog.dto';

interface State {
    dataCatalog: DataCatalogDto[];
    isLoading: boolean;
    error: string | null;
}

export const initialState: State = {
    dataCatalog: [],
    isLoading: false,
    error: null,
};

export const loadDataCatalog = createAsyncThunk(
    'documentGenerationDataCatalog/loadDataCatalog',
    async (_, thunkApi) => {
        try {
            const response = await admiDataCatalogService.getDataCatalog();

            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    },
);

const documentGenerationDataCatalogSlice = createSlice({
    name: 'documentGenerationDataCatalog',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadDataCatalog.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(loadDataCatalog.fulfilled, (state, action) => {
                state.isLoading = false;
                state.dataCatalog = action.payload;
            })
            .addCase(loadDataCatalog.rejected, (state, action) => {
                state.isLoading = false;
                state.error = (action.payload as string) || 'Failed to load data catalog';
            });
    },
});

export default documentGenerationDataCatalogSlice.reducer;
